<script setup lang="ts">
// oxlint-disable-next-line import/no-unassigned-import
import 'swiper/css'
import {Swiper, SwiperSlide} from 'swiper/vue'
import {resolveRelation, resolveMediaProps} from '~/utils/relations'
import type {Populated} from '~/types/populated'
import type {AboutUs} from '~/types/legacy'

const props = defineProps<{
  data: Populated<AboutUs>['imageGrid']
}>()
</script>

<template>
  <div v-if="data?.length" class="relative z-0 justify-center gap-4">
    <swiper class="!overflow-visible" slidesPerView="auto" grabCursor centeredSlides>
      <swiper-slide
        v-for="(item, i) in data"
        :key="item.id"
        :initialSlide="4"
        :index="i"
        :style="{height: 'auto !important', width: 'auto !important'}"
        class="mr-8"
      >
        <NuxtImg
          v-bind="resolveMediaProps(item)"
          fit="cover"
          class="h-full max-h-72 w-auto rounded-lg object-cover bordershadow-lg-gray hover:border-main-600 md:max-h-96 lg:max-h-[36rem]"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>
